export default [
    {
        "serviceOptionCode": "20",
        "serviceOptionName": "Daily Price Emails",
        "serviceStatusCode": "B",
        "serviceStatusName": "Funds Invested In",
        "commProcessCode": "    ",
        "commProcessName": "Default Initialization Value       ",
        "serviceEnrollDate": "2023-10-06",
        "serviceEndDate": null
    },
    {
        "serviceOptionCode": "21",
        "serviceOptionName": "Monthly Performance Emails",
        "serviceStatusCode": "C",
        "serviceStatusName": "Funds in plan",
        "commProcessCode": "    ",
        "commProcessName": "Default Initialization Value       ",
        "serviceEnrollDate": "2023-10-12",
        "serviceEndDate": null
    }
]
